export default {
    activePage: null,
    lastUpdate: [],
    currentApplicationId: "",
    currentProcessId: "",
    interfaceDirty: false,
    showSaveIfPermission: false,
    showMultiLangOption: false,
    showEnableAI: false,
    showEnableTaskAI: false,
    showAccessibilityOption: false,
    userListDelegation: [],
    defaultInfoApp: {
        companyName: "Aurachain",
        colorCode: "#FF8653"
    },
    fromAccountDisabled: false,
    disableOnLoad: false,
    fromMyTeamsTasksMenu: false,
    isOnLoadApplication: false,
    newProcessCreated: false
};
